import React from 'react';
import { getProfileImageUrl } from '../../services/api';

interface EmployeeAvatarProps {
  profileImageUrl?: string | null;
  updatedAt?: string;
  initials: string;
  avatarColor: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-12 w-12 text-sm',
  lg: 'h-16 w-16 text-xl',
};

const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  profileImageUrl,
  updatedAt,
  initials,
  avatarColor,
  size = 'sm',
  className = '',
}) => {
  const imageUrl = profileImageUrl ? getProfileImageUrl(profileImageUrl, updatedAt) : null;

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={`rounded-full object-cover flex-shrink-0 ${sizeClasses[size]} ${className}`}
      />
    );
  }

  return (
    <div
      className={`rounded-full ${avatarColor} flex items-center justify-center text-white font-medium flex-shrink-0 ${sizeClasses[size]} ${className}`}
    >
      {initials}
    </div>
  );
};

export default EmployeeAvatar;
